import React, {useState, useEffect} from 'react';
import {Input, Button, Pagination} from "antd";
import Select from "react-select";
import Skeleton from "react-loading-skeleton";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import {Modal} from "bootstrap";
import ModalConsent from "./ModalConsent";
import LoadingScreen from "../util/LoadingScreen";
import ModalPendingDocuments from "./ModalPendingDocuments";
import StatesSelect from "../util/StatesSelect";

const ModalNewAccreditation = ({
                                   visible,
                                   onClose,
                                   modalFilters,
                                   setModalFilters,
                                   fetchArrayCompany
                               }) => {
    const [ufs, setUfs] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedUf, setSelectedUf] = useState(null);
    const [loadingPage, setLoadingPage] = useState(false);
    const [selectedCity, setSelectedCity] = useState(null);
    const [modalLoading, setModalLoading] = useState(false);
    const [pendingDocsSend, setPendingDocsSend] = useState(false);
    const [modalResults, setModalResults] = useState([]);
    const [modalPagination, setModalPagination] = useState({current: 1, pageSize: 3, total: 0});
    const [pendingDocs, setPendingDocs] = useState([]);
    const [currentDoc, setCurrentDoc] = useState(null);

    const [modalPendingDocumentsVisible, setModalPendingDocumentsVisible] = useState(false);
    // Estados para o modal de consentimento
    const [companyId, setCompanyId] = useState(null);
    const [consentToDiscloseData, setConsentToDiscloseData] = useState(false);
    const [modalConsentVisible, setModalConsentVisible] = useState(false);

    // Função para lidar com mudanças nos campos de input
    const handleInputChange = (e) => {
        const {name, value} = e.target;
        setModalFilters((prevFilters) => ({...prevFilters, [name]: value}));
    };

    useEffect(() => {
        if (pendingDocs.length === 0 && companyId && pendingDocsSend) {
            setPendingDocsSend(false);
            handleConsentSubmit();
        }
    }, [pendingDocs, companyId]);


    // Função para lidar com a mudança da UF (estado)
    const handleUfChange = (selectedOption) => {
        setSelectedUf(selectedOption);
        setSelectedCity(null); // Resetar a cidade quando o estado mudar

        if (selectedOption) {
            ApiService.send("post", process.env.REACT_APP_URL_API + "address/city-uf", {uf: selectedOption.value}, false)
                .then((res) => {
                    const data = res.data;

                    if (!data.errors) {
                        setCities(
                            data.map((city) => ({
                                value: city.name,
                                label: city.name,
                                latitude: city.latitude,
                                longitude: city.longitude,
                            }))
                        );
                    }
                })
                .catch((error) => {

                });
        } else {
            setCities([]);
        }
    };

    // Função para selecionar uma empresa
    const handleSelectCompany = (companyId) => {
        setCompanyId(companyId);
        setConsentToDiscloseData(false);

        const consentModal = new Modal(document.getElementById('consentModal'));
        consentModal.show();
    };



    // Função para buscar resultados de empresas com base nos filtros
    const fetchModalResults = async () => {
        setModalLoading(true);
        try {
            const response = await ApiService.send("post", `${process.env.REACT_APP_URL_API}users/company-list`, {
                pagination: modalPagination.pageSize,
                page: modalPagination.current,
                name: modalFilters.name,
                state: selectedUf?.value,
                city: selectedCity?.value
            });

            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            setModalResults(data || []);
            setModalPagination(pagInfo);
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setModalLoading(false);
        }
    };

    const handleSubmitDocuments = async (event) => {
        event.preventDefault();
        setLoadingPage(true);
        const docFile = event.target.document_file.files[0];
        const formData = new FormData();
        formData.append('file', docFile ? docFile : "");
        formData.append('doc_number', docNumber);
        formData.append('state', selectedUfDoc ? selectedUfDoc.value : "");
        formData.append('id_type', currentDoc ? currentDoc.id_type : "");
        formData.append('id', currentDoc.id ? currentDoc.id : "");
        formData.append('type_of_person', typeOfPerson ? typeOfPerson.value : "");

        try {
            const response = await ApiService.sendArquivo('post', process.env.REACT_APP_URL_API + 'doc/register', formData);
            const {data} = ApiService.handleApiResponse(response);

            if (response.code === 200) {


                Swal.fire({
                    icon: 'success',
                    title: 'Documento salvo com sucesso!',
                });

                const updatedPendingDocs = pendingDocs.filter(doc => doc.id_type !== currentDoc.id_type);
                setPendingDocs(updatedPendingDocs);

                const modal = Modal.getInstance(document.getElementById('uploadDocumentModal'));
                modal.hide();

                if (updatedPendingDocs.length === 0 && companyId) {
                    const modalPendingDocumentsModal = Modal.getInstance(document.getElementById('pendingDocumentsModal'));
                    modalPendingDocumentsModal.hide();
                    handleSelectCompany(companyId);
                }
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro ao salvar documento',
                    text: data.message,
                });
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingPage(false);
        }
    };

    // Função para cancelar uma solicitação
    const handleCancelRequest = async (companyId) => {
        const result = await Swal.fire({
            title: "Tem certeza?",
            text: "Você não poderá reverter isso!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, cancelar!",
            cancelButtonText: "Cancelar",
        });

        if (result.isConfirmed) {
            try {
                setLoadingPage(true);

                // Chamada à API
                const response = await ApiService.send("delete", `${process.env.REACT_APP_URL_API}documents/removemyrequest`, {
                    user_id: companyId,
                });

                // Exibe mensagem de sucesso após a execução
                if (response.code === 200) {
                    Swal.fire({
                        title: "Sucesso!",
                        text: "Solicitação de credenciamento cancelada com sucesso.",
                        icon: "success",
                        confirmButtonText: "OK",
                    });

                    // Atualiza a lista de resultados (ou outro estado necessário)
                    fetchModalResults();
                } else {
                    // Exibe mensagem de erro caso a resposta não seja de sucesso
                    Swal.fire({
                        title: "Erro!",
                        text: response.data.message || "Erro ao cancelar solicitação.",
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                }
            } catch (error) {
                ApiService.handleApiError(error);
            } finally {
                setLoadingPage(false);
            }
        }
    };


    const handleConsentSubmit = async () => {
        if (consentToDiscloseData) {
            setLoadingPage(true);
            const consentModal = Modal.getInstance(document.getElementById('consentModal'));

            if (consentModal) {
                consentModal.hide();
            }

            try {
                const response = await ApiService.send("post", `${process.env.REACT_APP_URL_API}documents/adhere`, {
                    user_id: companyId.id,
                    consent: true,
                });

                Swal.fire({
                    title: "Sucesso!",
                    text: "Empresa selecionada com sucesso.",
                    icon: "success",
                    confirmButtonText: "OK",
                });
                fetchModalResults();

            } catch (error) {

                if (error.response?.code === 400) {

                  if(error.response.data.pending) {
                      setPendingDocs(error.response.data.pending);
                      const modalPending = new Modal(document.getElementById('pendingDocumentsModal'));
                      modalPending.show();
                      setPendingDocsSend(true);
                      // Verifica se existe uma mensagem de erro personalizada
                      const errorMessage = error.response?.data?.message || "Ocorreu um erro.";
                      const errorInstructions = error.response?.data?.errors?.join(", ") || "";

                      Swal.fire({
                          title: "Erro!",
                          html: `<p>${errorMessage}</p><p>${errorInstructions}</p>`,
                          icon: "error",
                          confirmButtonText: "OK",
                      });
                  }else{
                      ApiService.handleApiError(error);
                  }
                }  else {
                    const errorMessage = error.response?.data?.message || "Ocorreu um erro inesperado.";
                    Swal.fire({
                        title: "Erro!",
                        text: errorMessage,
                        icon: "error",
                        confirmButtonText: "OK",
                    });
                }
            } finally {
                setLoadingPage(false);
            }
        } else {
            Swal.fire({
                title: "Erro",
                text: "Você deve consentir com a divulgação dos seus dados para continuar.",
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };




    useEffect(() => {
        fetchModalResults();
    }, [modalPagination.current]);

    return (
        <>
            {loadingPage && <LoadingScreen/>}
            <div className="modal fade" id="newAccreditationModal" tabIndex="-1"
                 aria-labelledby="newAccreditationModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="newAccreditationModalLabel">Novo Credenciamento</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Nome</label>
                                <Input
                                    placeholder="Digite o nome"
                                    value={modalFilters.name}
                                    onChange={(e) => handleInputChange(e)}
                                    name="name"
                                />
                            </div>
                            <div className="row">
                                <div className="form-group col-4">
                                    <label>Estado</label>
                                    <StatesSelect value={selectedUf} onChange={handleUfChange} />
                                </div>
                                <div className="form-group col-8">
                                    <label>Cidade</label>
                                    <Select
                                        value={selectedCity}
                                        onChange={setSelectedCity}
                                        options={cities}
                                        placeholder="Selecione a Cidade"
                                        isDisabled={!selectedUf}
                                        isSearchable
                                        menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                        styles={{
                                            menuPortal: base => ({
                                                ...base,
                                                zIndex: 9999
                                            }), // Definindo z-index alto
                                            menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-primary"  onClick={() =>fetchModalResults()}>
                                        <i className="fa fa-search"></i> Buscar
                                    </button>
                                </div>
                            </div>
                            <div className="modal-results mt-4">
                                {modalLoading ? (
                                    <Skeleton count={5}/>
                                ) : (
                                    modalResults.length > 0 ? (
                                        modalResults.map((result, index) => (
                                            <div key={index} className="duty-card shadow-sm mb-3">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-2">
                                                            <img className="img-fluid" alt="User"
                                                                 src={result.profile_image || process.env.REACT_APP_URL_STORAGE + 'src/perfil_icone.png'}
                                                                 style={{width: '50px', height: '50px'}}/>
                                                        </div>
                                                        <div className="col-8">
                                                            <h5>{result.name}</h5>
                                                            <p>{result.city} - {result.state}</p>
                                                            <p>
                                                                {result.situation === "pending" && (
                                                                    <span><i
                                                                        className="fa fa-hourglass-half text-warning"></i> Pendente Análise</span>
                                                                )}
                                                                {result.situation === "accepted" && (
                                                                    <span><i
                                                                        className="fa fa-check-circle text-success"></i> Aprovado</span>
                                                                )}
                                                                {result.situation === "cancel" && (
                                                                    <span><i
                                                                        className="fa fa-close text-danger"></i> Cancelada</span>
                                                                )}
                                                                {result.situation === "refused" && (
                                                                    <span> <i
                                                                        className="fa fa-times-circle text-danger"></i> Rejeitado</span>
                                                                )}
                                                                {result.situation === "remake" && (
                                                                    <span> <i className="fa fa-edit text-warning"></i> Reenviar Informações</span>
                                                                )}
                                                            </p>
                                                        </div>

                                                        <div className="col-2 d-flex align-items-center">
                                                            {(result.situation === "pending" || result.situation === "remake" ) && (
                                                                <button type="button"
                                                                    className="btn btn-danger btn-sm mt-2"
                                                                    onClick={() => handleCancelRequest(result.id)}
                                                                >
                                                                 <i className="fa fa-close"></i> Cancelar
                                                                </button>
                                                            )}

                                                            {(result.situation === null || result.situation === 'cancel' || result.situation === 'refused') && (
                                                                <button type="button" className="btn btn-primary btn-sm mt-2"
                                                                        onClick={() => handleSelectCompany(result)}>
                                                                   <i className="fa fa-plus-square"></i> Solicitar
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="duty-card shadow-sm mb-3">
                                            <div className="card-body">
                                                <div className="alert alert-primary" role="alert">Nenhum resultado
                                                    encontrado.
                                                </div>
                                            </div>
                                        </div>
                                    )
                                )}
                                <Pagination
                                    className="mt-4"
                                    current={modalPagination.current}
                                    pageSize={modalPagination.pageSize}
                                    total={modalPagination.total}
                                    onChange={(page) => {
                                        setModalPagination((prevPagination) => ({
                                            ...prevPagination,
                                            current: page,
                                        }));
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal de Consentimento */}
            <ModalConsent
                show={modalConsentVisible}
                onClose={() => setModalConsentVisible(false)}
                consentToDiscloseData={consentToDiscloseData}
                setConsentToDiscloseData={setConsentToDiscloseData}
                handleConsentSubmit={handleConsentSubmit}
            />

            {/* Modal de Documentos Pendentes */}
            <ModalPendingDocuments
                show={modalPendingDocumentsVisible}
                onClose={() => setModalPendingDocumentsVisible(false)}
                initialPendingDocs={pendingDocs}
                ufs={ufs}
                updatePendingDocsInParent={setPendingDocs} // Passando a função que atualiza o estado no pai
            />

        </>
    );
};

export default ModalNewAccreditation;
